import { Page } from '@/core/architecture'

import { ConsoleItemsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleItems Page
 * Implemented as a practical sample.
 */
export const ConsoleItems: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleItemsTemplate state={state} {...actions} />
}
